import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { PresentSleepDetails } from './PresentSleepDetails';
import { SleepDetailsData } from './ContainSleepDetails';

const LABELS = {
  bedtime: 'Bedtime',
  timeToFallAsleep: 'Time to fall asleep',
  wakeUpTime: 'Wake-up time',
  nighttimeAwakenings: 'Nighttime awakenings',
  extraDetails: 'Anything else about your night?',
  infoTitle: 'Why we ask',
  infoBody: 'Tracking your nights for a week makes your sleep patterns visible.',
};

const BEDTIMES = ['9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM', '12:00 AM'];
const DURATIONS = ['5min', '10min', '20min', '30min', '45min', '1h+'];
const WAKE_UPS = ['6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM'];

const buildData = (overrides?: Partial<SleepDetailsData>): SleepDetailsData => ({
  labels: LABELS,
  bedtime: '11:00 PM',
  onChangeBedtime: () => undefined,
  bedtimeOptions: BEDTIMES,
  timeToSleep: '20min',
  onChangeTimeToSleep: () => undefined,
  timeToSleepOptions: DURATIONS,
  wakeUp: '7:30 AM',
  onChangeWakeUp: () => undefined,
  wakeUpOptions: WAKE_UPS,
  awakenings: 1,
  onChangeAwakenings: () => undefined,
  notes: '',
  onChangeNotes: () => undefined,
  ...overrides,
});

const meta = {
  title: 'Diary/Frames/SleepDetails',
  component: PresentSleepDetails,
  args: {
    questionId: 'story-sleep',
    questionText: 'Let\'s get the details of your night',
    margin: 16,
    data: buildData(),
  },
  decorators: [
    Story => (
      <View style={{ width: 375, height: 700 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof PresentSleepDetails>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};

const InteractiveSleepDetails = (args: React.ComponentProps<typeof PresentSleepDetails>) => {
  const [awakenings, setAwakenings] = useState(1);
  const [notes, setNotes] = useState('');
  return (
    <View style={{ width: 375, height: 700 }}>
      <PresentSleepDetails
        {...args}
        data={buildData({
          awakenings,
          onChangeAwakenings: setAwakenings,
          notes,
          onChangeNotes: setNotes,
        })}
      />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveSleepDetails {...args} />,
};
